import { IGetPartResponse } from '../../types/parts';
import { axiosInstance } from '../axiosInstance';

export const getPart = async (id: string): Promise<IGetPartResponse> => {
  const response = await axiosInstance.get(`/view/parts/${id}`);

  return response.data;
};

export const getPartStatus = async (id: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/view/parts/short/${id}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (err) {
    return { status: (err as any).status };
  }
};
